import React, { useEffect, useState } from "react";
import { Form, Button, Typography, Flex, Grid } from "antd";
import { App } from "antd";
import InputField from "../../../components/Input/Input";
import { useForm } from "antd/es/form/Form";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createOrUpdateLocation, fetchLocationsList } from "../locationsThunks";
import { setSelectedLocation, setIsEditLocation } from "../locationsSlice";
import { getAccessType } from "../../../lib/functions";
import LocationFormBody from "./LocationFormBody";

const { Title } = Typography;
const { useBreakpoint } = Grid;

const CreateLocationForm = () => {
  const { modal } = App.useApp();
  const dispatch = useDispatch();
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const [form] = useForm();

  let [access_type, access_type_set] = useState("");

  useEffect(() => {
    const access = getAccessType("location_entry");
    access_type_set(access);
  }, []);

  const { isEditLocation, selectedLocation } = useSelector(
    (state) => state.locations
  );

  useEffect(() => {
    if (isEditLocation && selectedLocation) {
      form.setFieldsValue(selectedLocation);
    } else {
      form.resetFields();
    }
  }, [isEditLocation, selectedLocation]);

  const handleCancel = () => {
    dispatch(setSelectedLocation(null));
    dispatch(setIsEditLocation(false));
    navigate(-1);
  };

  const handleSave = async (values) => {
    try {
      await dispatch(
        createOrUpdateLocation({
          ...values,
          action: isEditLocation ? "update" : "create",
          location_id: selectedLocation?.location_id || 0,
        })
      ).unwrap();

      modal.success({
        title: isEditLocation
          ? "Location updated successfully"
          : "Location created successfully",
      });

      dispatch(setSelectedLocation(null));
      dispatch(setIsEditLocation(false));
      navigate("/settings/location-manage");
      dispatch(fetchLocationsList());
    } catch (error) {
      modal.warning({
        title: error.message || "Save failed",
      });
    }
  };

  return (
    <div className="location-form">
      <Title level={2} style={{ marginBottom: "32px" }}>
        {isEditLocation ? "Update Location" : "Create New Location"}
      </Title>

      <Form
        form={form}
        layout="horizontal"
        onFinish={handleSave}
        variant="filled"
        style={{ maxWidth: "1400px" }}
        colon={false}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 18 }}
      >
        <Flex
          gap={!screens.md || !screens.xl ? 10 : 80}
          justify="center"
          style={{
            flexDirection: !screens.md || !screens.xl ? "column" : "row",
            width: "100%",
            marginBottom: "24px",
          }}
        >
          <Flex
            vertical
            gap={10}
            style={{ width: !screens.md || !screens.xl ? "100%" : "40%" }}
          >
            <LocationFormBody />
          </Flex>
        </Flex>
        <Flex style={{ marginBottom: "32px", width: "40%" }} gap={32}>
          <Button
            size="large"
            shape="default"
            onClick={handleCancel}
            className="traic-button"
          >
            Back
          </Button>
          {access_type == "WRITE" && <>
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              className="traic-button"
              data-testid="btn-save-location"
            >
              {isEditLocation ? "Update" : "Save"}
            </Button>
          </>}
        </Flex>
      </Form>
    </div>
  );
};

export default CreateLocationForm;
